import { curry, isNil, map, pipe } from "ramda";
import { of } from "most";
import { tap } from "common/general";
import { getProject, getOrganization } from "application/applicationReducer";

const VERSION = 3

const getObject = key => {
  try {
    const serialized = localStorage.getItem(key);

    if (isNil(serialized)) {
      return null;
    } else {
      return JSON.parse(serialized);
    }
  } catch (error) {
    console.log("Error loading state from localStorage: %O", error);
    return null;
  }
};

const putObject = (key, object) => {
  try {
    const serialized = JSON.stringify(object);
    localStorage.setItem(key, serialized);
  } catch (error) {
    console.log("Error saving state to localStorage: %O", error);
  }
};

const removeObject = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.log("Error removing object from localStorage: %O", error);
  }
};

// fetchFromLocalStorage :: String -> Object
export const fetchFromLocalStorage = pipe(
  of,
  map(getObject),
  map(obj => (isNil(obj) ? {} : obj)),
);

export const saveToLocalStorage = curry((key, data) =>
  pipe(of, tap(({ key, data }) => putObject(key, data)))({ key, data }),
);

export const removeObjectFromLocalStorage = key =>
  pipe(of, tap(({ key }) => removeObject(key)))({ key });

export const createKey = curry(
  (applicationState, step) =>
    `${getProject(applicationState).projectKey}-${
      getOrganization(applicationState).alias
    }-${step}-${VERSION}`,
);
